define([
	"dojo/_base/declare",
	"csi/table/MoveUpDown"
], function(declare,MoveUpDown) {

	return declare(MoveUpDown, {
		bHold: false
	});
});
